export const SENTRY_RELEASE: string | undefined = 'bcdc6bf32d6a319a2508d2013dd45b5303f6fc84';
